// @flow

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import styles from './depositSlipDashboard.scss';
import { setPageName } from '../../../../services/pageService/pageActionCreator';
import ZoomTable from '../../../commons/zoomTable/zoomTable';

import {
  getDashboardData,
  getDepositSlipDetailForModal,
  updatePageNumber
} from './depositSlipDashboardRedux/depositSlipDashboardActionCreator';

import DateRangeFilter from '../../../commons/dateFilter/dateFilter';
import Select from '../../../commons/formElements/select/select';
import { typeFilterList } from './depositSlipDashboardHelper';
import SearchBox from '../../../commons/searchBox/searchBox';
import DepositSlipDetail from './depositSlipModal';
import DepositSlipCancellationModal from './depositSlipCancellationModal';

type Props = {
  setPageName: Function,
  depositSlipDashboardState: Object,
  getDashboardData: Function,
  cancelDepositSlipEnabled: boolean,
  getDepositSlipDetailForModal: Function
};

type State = {
  row: Object,
  resetSearchText: boolean,
  startDate: number,
  endDate: number,
  cnotes: Object,
  filterType: Object,
  showDepositSlipModal: boolean,
  showDepositSlipCancellationModal: boolean,
  selectedDepositSlipId: number
};

const pageObj = {
  pageName: 'DEPOSIT SLIP',
  betaPage: false
};

const SEARCH_PLACEHOLDER = 'Search By Cnote';

class DepositSlipDashboard extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.componentKey = 'DEPOSITED_SLIPS_DASHBOARD';
    this.state = {
      resetSearchText: false,
      startDate: null,
      endDate: null,
      filterType: null,
      cnotes: [],
      showDepositSlipModal: false,
      showDepositSlipCancellationModal: false,
      selectedDepositSlipId: 0,
      viewDetailsType: ''
    };
    const { cancelDepositSlipEnabled } = this.props;
    this.tableActionFunctions = {
      viewDetails: (rowData, type) => {
        this.onViewDetails(rowData, type);
      },
      cancel: rowData => {
        this.onCancel(rowData);
      },
      cancelDepositSlipEnabled
    };

    this.toggleShowModal = this.toggleShowModal.bind(this);
    this.toggleCancellationModal = this.toggleCancellationModal.bind(this);
  }

  componentDidMount() {
    this.props.setPageName(pageObj);
    this.dashboardDataCall();
  }

  componentWillReceiveProps(nextProps: Object) {
    const { depositSlipDashboardState } = this.props;
    const { cancellationSuccess } = depositSlipDashboardState;
    if (
      nextProps.depositSlipDashboardState.cancellationSuccess &&
      cancellationSuccess !==
        nextProps.depositSlipDashboardState.cancellationSuccess
    ) {
      this.toggleCancellationModal();
      this.dashboardDataCall();
    }
  }

  onViewDetails(rowData: Object, type: string) {
    this.setState({
      selectedDepositSlipId: rowData.id,
      showDepositSlipModal: true,
      viewDetailsType: type
    });
  }

  onCancel(rowData: Object) {
    this.setState({
      selectedDepositSlipId: rowData.id,
      showDepositSlipCancellationModal: true
    });
  }

  onDateFilterChange(start, end) {
    this.setState(
      {
        startDate: start,
        endDate: end
      },
      () => {
        this.dashboardDataCall();
      }
    );
  }

  onFilterChange(key, obj) {
    this.setState(
      {
        [key]: obj
      },
      () => {
        this.dashboardDataCall();
      }
    );
  }

  onSearchValueChange(cnotes: string) {
    if (cnotes) {
      this.onFilterChange('cnotes', cnotes.split(','));
    } else {
      this.onFilterChange('cnotes', []);
    }
  }

  toggleShowModal() {
    this.setState({
      showDepositSlipModal: false
    });
  }

  toggleCancellationModal() {
    this.setState({
      showDepositSlipCancellationModal: false
    });
  }

  dashboardDataCall() {
    this.props.getDashboardData({
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      type: this.state.filterType && this.state.filterType.val,
      cnotes: this.state.cnotes
    });
  }

  renderDateFilter() {
    return (
      <div
        className={`${styles.filterComponentWrapper} zt-filter-component-wrapper`}
      >
        <DateRangeFilter
          setDateFilter={(start, end) => this.onDateFilterChange(start, end)}
          displayFormat="DD MMM YY"
          minusDays={1}
        />
      </div>
    );
  }

  renderTypeFilter() {
    return (
      <div
        className={`${styles.filterComponentWrapper} zt-filter-component-wrapper`}
      >
        <Select
          label="Type"
          optionsArrOfObj={typeFilterList}
          selectedOpt={this.state.filterType}
          onSelect={(val, obj) => {
            this.onFilterChange('filterType', obj);
          }}
          disableNone={true}
          enableSearch={true}
        />
      </div>
    );
  }

  renderSearchBox() {
    return (
      <div
        className={`${styles.filterComponentWrapper} zt-filter-component-wrapper`}
      >
        <SearchBox
          placeHolder={SEARCH_PLACEHOLDER}
          onSearchValueChange={val => this.onSearchValueChange(val)}
          resetSearchText={this.state.resetSearchText}
        />
      </div>
    );
  }

  renderFilterPanel() {
    return (
      <div
        className={`${styles.filterPanelParent} zt-filter-panel-parent l-row a-center`}
      >
        <div
          className={`${styles.filterPanelLeft} zt-filter-panel-left l-row flex-70`}
        >
          <div
            className={`${styles.filterLabel} zt-filter-label l-row a-center`}
          >
            Filter By:
          </div>
          {this.renderDateFilter()}
          {this.renderTypeFilter()}
        </div>
        <div
          className={`${styles.filterPanelRight} zt-filter-panel-right l-row flex-30 j-end`}
        >
          {this.renderSearchBox()}
        </div>
      </div>
    );
  }

  renderTable() {
    return (
      <div className={`${styles.tableWrapper}`}>
        <ZoomTable
          configKey={this.componentKey}
          tableData={
            (this.props.depositSlipDashboardState &&
              this.props.depositSlipDashboardState.dashboardData) ||
            []
          }
          tableDataLength={this.props.depositSlipDashboardState.totalElements}
          loading={this.props.depositSlipDashboardState.isLoading}
          paginationProps={{
            showPagination: true,
            pageSize: this.props.depositSlipDashboardState.totalElements
              ? Math.min(
                  this.props.depositSlipDashboardState.totalElements,
                  this.props.depositSlipDashboardState.pageSize
                )
              : 0,
            serverSidePagination: true,
            pages: Math.ceil(
              this.props.depositSlipDashboardState.totalElements /
                this.props.depositSlipDashboardState.pageSize
            ),
            onFetchData: tableState => {
              if (
                this.props.depositSlipDashboardState.pageNumber !==
                tableState.page
              ) {
                this.props.updatePageNumber(tableState.page);
                this.dashboardDataCall();
              }
            }
          }}
          actionFunctions={this.tableActionFunctions}
        />
      </div>
    );
  }

  render() {
    const {
      showDepositSlipCancellationModal,
      selectedDepositSlipId
    } = this.state;
    const { depositSlipDashboardState } = this.props;
    return (
      <div className={`${styles.depositedSlipDashboardWrapper}`}>
        {this.renderFilterPanel()}
        {this.renderTable()}
        <DepositSlipDetail
          showModal={this.state.showDepositSlipModal}
          title="Deposit Slip Details"
          closeModal={this.toggleShowModal}
          depositSlipId={this.state.selectedDepositSlipId}
          submitBankSlipModalLoader={
            depositSlipDashboardState.submitBankSlipModalLoader
          }
          type={this.state.viewDetailsType}
        />
        <DepositSlipCancellationModal
          showModal={showDepositSlipCancellationModal}
          isCancellationLoading={
            depositSlipDashboardState.isCancellationLoading
          }
          title="Cancel Deposit Slip"
          closeModal={this.toggleCancellationModal}
          depositSlipId={selectedDepositSlipId}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  depositSlipDashboardState: state.depositSlipDashboardState,
  cancelDepositSlipEnabled:
    state.userProfile.authorities.indexOf(
      'ROLE_ZOOM_DEPOSIT_SLIP_CANCELLATION'
    ) !== -1
});

const mapDispatchToProps = dispatch => ({
  setPageName: bindActionCreators(setPageName, dispatch),
  getDashboardData: bindActionCreators(getDashboardData, dispatch),
  updatePageNumber: bindActionCreators(updatePageNumber, dispatch),
  getDepositSlipDetailForModal: bindActionCreators(
    getDepositSlipDetailForModal,
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DepositSlipDashboard);
